// Lojas do relatório: o campo é o mesmo MultipleSelectUnidade do filtro do
// painel, que fala em chave JSON {idUnidade, nome}; o relatório fala em id.
// Sem React aqui de propósito — é a parte que os testes cobrem sem montar a página.

export function chaveUnidade(loja) {
    return JSON.stringify({ idUnidade: loja?.idUnidade, nome: loja?.nome })
}

export function chavesDosIds(ids, lojas) {
    const escolhidos = new Set((ids || []).map(Number))
    return (lojas || [])
        .filter(loja => escolhidos.has(Number(loja?.idUnidade)))
        .map(chaveUnidade)
}

// Devolve os ids das chaves marcadas, sem repetição. Chave quebrada é ignorada.
export function idsDasChaves(chaves) {
    const ids = []
    for (const chave of chaves || []) {
        let id = NaN
        try {
            id = Number(typeof chave === 'string' ? JSON.parse(chave)?.idUnidade : chave?.idUnidade)
        } catch (e) {
            id = NaN
        }
        if (Number.isFinite(id) && !ids.includes(id)) {
            ids.push(id)
        }
    }
    return ids
}

// O relatório abre com as lojas que a pessoa escolheu ao entrar no Analytics.
// Se ainda não escolheu nenhuma (ou nenhuma delas é dela), abre com todas.
export function unidadesIniciais(lojas, selecaoDoPainel) {
    const permitidas = (lojas || []).map(loja => Number(loja?.idUnidade)).filter(Number.isFinite)
    const doPainel = (selecaoDoPainel || [])
        .map(item => Number(item?.idUnidade))
        .filter(id => Number.isFinite(id) && permitidas.includes(id))

    return doPainel.length ? [...new Set(doPainel)] : permitidas
}

// O que está escrito no campo fechado. Vazio nunca quer dizer "todas": a
// pessoa lê exatamente o que vai entrar no relatório.
export function rotuloSelecao(quantas, total) {
    if (!quantas) {
        return 'Nenhuma loja escolhida'
    }
    if (total <= 1) {
        return '1 loja'
    }
    if (quantas >= total) {
        return `Todas as ${total} lojas`
    }
    return `${quantas} de ${total} lojas`
}
